/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 31d557939519
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";

export type DeleteTriggerGlobals = { cloud_name?: string | undefined };

export const DeleteTriggerGlobals$zodSchema: z.ZodType<DeleteTriggerGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type DeleteTriggerRequest = { id: string };

export const DeleteTriggerRequest$zodSchema: z.ZodType<DeleteTriggerRequest> = z
  .object({
    id: z.string().describe("The ID of the trigger."),
  });

export type DeleteTriggerResponse = MessageResponse | ApiError;

export const DeleteTriggerResponse$zodSchema: z.ZodType<DeleteTriggerResponse> =
  z.union([
    MessageResponse$zodSchema,
    ApiError$zodSchema,
  ]);
